module.exports = __webpack_public_path__ + "img/8group-vrgroup-icon.38970c69.svg";